import { reheat, freeze, visibleCanvas, inIframe } from './utils'
import { tick } from './tick'
import { findByPosition } from './node'
import { click, unclick } from './action'

const transform = (): object => {
  return globalThis._TRANSFORM_
}

export const subject = (): void => {
  const node = findByPosition(event.layerX, event.layerY)
  if (globalThis._SIMULATION_.nodes().length <= 3) return
  if (node?.draggable === true) {
    node.x = transform().applyX(node.x)
    node.y = transform().applyY(node.y)
    click(node)
    return node
  }
}

export const dragStart = (event: object): void => {
  if (event.active === 0) reheat()
  event.subject.fx = transform().invertX(event.x)
  event.subject.fy = transform().invertY(event.y)
  visibleCanvas().style.cursor = 'grabbing'
}

export const dragging = (event: object): void => {
  event.subject.fx = transform().invertX(event.x)
  event.subject.fy = transform().invertY(event.y)
}

export const dragEnd = (event: object): void => {
  if (event.active === 0) freeze()
  event.subject.fx = null
  event.subject.fy = null
  visibleCanvas().style.cursor = 'grab'
}

export const zoomStart = (event: object): void => {
  globalThis._TRANSFORM_ = event.transform
}

export const zooming = (event: object): void => {
  globalThis._TRANSFORM_ = event.transform
  if (event.sourceEvent.type === 'wheel') {
    unclick('keepHighlight')
    if (event.sourceEvent.deltaY < 0) {
      visibleCanvas().style.cursor = 'zoom-in'
    } else {
      visibleCanvas().style.cursor = 'zoom-out'
    }
  } else if (visibleCanvas().style.cursor !== 'move') {
    visibleCanvas().style.cursor = 'move'
  }
  tick()
}

export const zoomEnd = (event: object): void => {
  globalThis._TRANSFORM_ = event.transform
  visibleCanvas().style.cursor = 'pointer'
  tick()
}

export const zoomFilter = (event: object): void => {
  if (event.type === 'dblclick') {
    return false
  } else if (globalThis._CONFIGURATION_ === undefined || (event.type !== 'wheel' && event.type !== 'touchstart')) {
    return true
  }
  if (inIframe() && globalThis._CONFIGURATION_.interactionLock === true) {
    if (event.type === 'wheel' && (event.metaKey === true || (event.ctrlKey === true && !pinchZooming(event)))) return true
    if (event.type === 'touchstart') return true
    controller().lock()
    return false
  }
  return true
}

export const zoomIn = (): void => {
  if (transform().k >= maxZoomThreshold()) {
    setZoom(maxZoom())
    return
  }
  setZoom(parseFloat(transform().k) + zoomStep())
}

export const zoomOut = (): void => {
  if (transform().k <= minZoomThreshold()) {
    setZoom(minZoom())
    return
  }
  setZoom(parseFloat(transform().k) - zoomStep())
}

const setZoom = (k: number): void => {
  transform().k = k
  tick()
}

const minZoom = (): number => {
  return parseFloat(globalThis._CONFIGURATION_.scale.extent.min)
}

const maxZoom = (): number => {
  return parseFloat(globalThis._CONFIGURATION_.scale.extent.max)
}

const zoomStep = (): number => {
  return 0.1
}

const minZoomThreshold = (): number => {
  return minZoom() + zoomStep()
}

const maxZoomThreshold = (): number => {
  return maxZoom() - zoomStep()
}

const pinchZooming = (event: object): boolean => {
  // Scrolling with a scroll wheel/trackpad generates higher deltaY values
  return event.ctrlKey === true && Math.abs(event.deltaY) < 25
}

const controller = (): object => {
  return globalThis._APPLICATION_.getControllerForElementAndIdentifier(document.getElementById('interaction-lock'), 'interaction-lock')
}

export const zoomWheelDelta = (event: object): void => {
  // Adapted from d3-zoom source
  // https://github.com/d3/d3-zoom/blob/1bccd3fd56ea24e9658bd7e7c24e9b89410c8967/src/zoom.js#L35
  // https://github.com/d3/d3-zoom/issues/204#issuecomment-635896854
  return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (pinchZooming(event) ? 5 : 1) // eslint-disable-line
}
